import { Link, useNavigate } from "react-router-dom";

function Header() {
  const navigate = useNavigate();

  return (
    <>
      <section className="blue-bg">
        <div className="container py-2">
          <div className="d-flex justify-content-between align-items-center py-1">
            <div className="d-flex justify-content-end align-items-center">
              <p className="fst-italic fs-5 lh-1 m-0 me-6 text-white me-3">
                <i className="bi bi-telephone me-2"></i> +91 7677245574
              </p>
              <p className="fst-italic fs-5 lh-1 m-0 me-6 text-white">
                <i className="bi bi-envelope me-2"></i> albedoinfo1@gmail.com
              </p>
            </div>
            <div className="d-flex justify-content-end align-items-center">
              <p className="fst-italic fs-5 lh-1 m-0 text-white d-lg-block d-none">
                <i className="bi bi-briefcase me-2"></i> Albinstitute Pvt. Ltd
                &nbsp;[U80301JH2021PTC017016]
              </p>
            </div>
          </div>
        </div>
      </section>

      <nav className="navbar navbar-expand-lg py-1 px-0 my-header-bg sticky-top z-5">
        <div className="container">
          <div className="d-flex align-items-center">
            <button
              class="navbar-toggler collapsed me-2"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbar-default"
              aria-controls="navbar-default"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span class="icon-bar top-bar mt-0"></span>
              <span class="icon-bar middle-bar"></span>
              <span class="icon-bar bottom-bar"></span>
            </button>

            <Link to="/">
              <img
                src="/assets/images/logo.png"
                className="d-lg-none d-block"
                width="100"
              />
              <img
                src="/assets/images/logo.png"
                width="100"
                className="me-5 d-lg-block d-none"
              />
            </Link>
          </div>
          <div className="ms-auto d-flex align-items-center order-lg-3">
            <div>
              <div className="d-flex align-items-center">
                <div class="d-flex gap-1 align-items-center justify-content-end me-lg-5">
                  <img src="/assets/images/facebook.png" width="30" />
                  <img src="/assets/images/instagram.png" width="30" />
                  <img src="/assets/images/x.png" width="30" />
                  <img src="/assets/images/linkdin.png" width="30" />
                  <img src="/assets/images/youtube.png" width="30" />
                </div>
                <a
                  href="https://api.whatsapp.com/send?phone=917677245574&text=Hi"
                  target="_blank"
                  class="btn btn-icon btn-success rounded-circle d-none d-md-inline-flex ms-2"
                >
                  <i class="bi bi-whatsapp fs-4 align-middle"></i>
                </a>
                <div className="header-btn-height ms-1 d-lg-block d-none">
                  <a
                    href="tel:+917677245574"
                    className="cursor-pointer bg-gradient-blue text-white fw-normal rounded-pill px-4 h-100 d-flex align-items-center"
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="fs-7 d-flex align-items-center">
                        <i className="bi bi-telephone-fill me-2 fs-4"></i> For
                        Enquiry / Call Now
                      </div>
                      <i className="bi bi-chevron-down fs-5 ms-5"></i>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="collapse navbar-collapse" id="navbar-default">
            <ul className="navbar-nav  mt-3 mt-lg-0">
              <li class="nav-item">
                <Link class="nav-link" to="/">
                  Home
                </Link>
              </li>
              <li class="nav-item dropdown">
                <span class="nav-link dropdown-toggle cursor-pointer">
                  About Us
                </span>
                <ul class="dropdown-menu" aria-labelledby="navbarLanding">
                  <li>
                    <Link to="/about" class="dropdown-item">
                      About Albedo Institute
                    </Link>
                  </li>
                  <li>
                    <a href="#" class="dropdown-item">
                      About Founder
                    </a>
                  </li>
                  <li>
                    <a href="#" class="dropdown-item me-3">
                      Our Faculty
                    </a>
                  </li>
                  <li>
                    <a href="#" class="dropdown-item me-3">
                      Career in Albedo
                    </a>
                  </li>
                </ul>
              </li>
              <li class="nav-item">
                <Link class="nav-link" to="/courses">
                  Courses
                </Link>
              </li>
              <li class="nav-item">
                <Link class="nav-link" to="/">
                  Admission
                </Link>
              </li>
              <li class="nav-item dropdown">
                <span class="nav-link dropdown-toggle cursor-pointer">
                  Gallery
                </span>
                <ul class="dropdown-menu" aria-labelledby="navbarLanding">
                  <li>
                    <a href="#" class="dropdown-item">
                      Seminars & Events
                    </a>
                  </li>
                  <li>
                    <a href="#" class="dropdown-item">
                      Image Gallery
                    </a>
                  </li>
                  <li>
                    <a href="#" class="dropdown-item">
                      Video Gallery
                    </a>
                  </li>
                </ul>
              </li>
              <li class="nav-item">
                <Link class="nav-link" to="/contact">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Header;
